import { BaseSettingsEndpoints } from './base';
import {
  TableOverviewResponse,
  TableOverviewParams
} from '../types/table-overview';
import { PossibleDateSort } from '../types/table-overview';

const TABLE_OVERVIEW_BASE_PATH = '/v1/dashboard';

export class TableOverviewClient extends BaseSettingsEndpoints {
  async getTableOverview({
    office_ids,
    division_ids,
    date,
    tz,
    user_tz,
    team_id,
    limit,
    cursor,
    user_id,
    date_sort_order,
    date_sort,
    is_single_date
  }: TableOverviewParams) {
    const params = new URLSearchParams();

    if (date) {
      params.set('date', date);
    }

    if (tz) {
      params.set('tz', tz);
    }

    if (user_tz) {
      params.set('user_tz', user_tz);
    }

    if (team_id && team_id.length > 0) {
      team_id.forEach((id) => params.append('team_id', id));
    }

    if (limit) {
      params.set('limit', limit.toString());
    }

    if (cursor) {
      params.set('cursor', cursor);
    }

    if (user_id && user_id.length > 0) {
      user_id.forEach((id) => params.append('user_id', id));
    }

    if (date_sort) {
      params.set('date_sort_order', date_sort_order ?? PossibleDateSort.ASC);
      params.set('date_sort', date_sort);
    }

    if (is_single_date) params.set('date_only', 'true');

    if (office_ids && office_ids.length > 0) {
      office_ids.forEach((id) => params.append('office_id', id));
    }

    if (division_ids && division_ids.length > 0) {
      division_ids.forEach((id) => params.append('division_id', id));
    }

    const queryString = params.toString();
    const url = `${TABLE_OVERVIEW_BASE_PATH}/table_overview${queryString ? `?${queryString}` : ''}`;

    return this.get<TableOverviewResponse>(url);
  }
}
